/**
 * E2E auth-bypass flag — resolved at BUILD time, never at runtime.
 *
 * `__E2E_AUTH_BYPASS__` is a compile-time constant injected by each app's Vite
 * `define` block (see `e2eAuthBypassPlugin` / `createDashboardConfig`). It is
 * `true` ONLY when the dev server is started with `VITE_E2E_AUTH_BYPASS=1`, and
 * is statically replaced with `false` in every production build (then
 * dead-code-eliminated by the minifier).
 *
 * Why this exists / SECURITY (S02 F-5, 2026-06-13 audit):
 *   The previous implementation read `window.__E2E_AUTH_BYPASS__` at RUNTIME.
 *   Vite's `define` replaces the bare identifier `__E2E_AUTH_BYPASS__`, but it
 *   does NOT replace the property access `window.__E2E_AUTH_BYPASS__` — so that
 *   read survived verbatim into production bundles. Any script able to set
 *   `window.__E2E_AUTH_BYPASS__ = true` (an XSS payload, a malicious extension,
 *   a prototype-pollution gadget) could then disable AuthGuard entirely. Using
 *   the build-time constant removes the runtime-settable global: in prod the
 *   branch is provably `false` and elided; in E2E dev it is `true` at build.
 *
 * The `typeof` guard keeps this safe to import from an app whose Vite config
 * does not define the symbol — `typeof <undefined-global>` yields `"undefined"`
 * rather than throwing a ReferenceError.
 */
declare const __E2E_AUTH_BYPASS__: boolean;

export function isE2EAuthBypass(): boolean {
  return typeof __E2E_AUTH_BYPASS__ !== "undefined" && __E2E_AUTH_BYPASS__ === true;
}
